// src/containers/MainContainer.jsx
import React, { useEffect, useContext } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import Home from "../screens/Home/Home";
import DriverData from "../screens/Home/DriverData/DriverData";
import ReceResults from "../screens/ReceResults/ReceResults";
import Championships from "../screens/Championships/Championships";
import CircuitRecords from "../screens/CircuitRecords/CircuitRecords";
import VehicleRecords from "../screens/VehicleRecords/VehicleRecords";
import Customer from "../screens/Customer/Customer";
import { DataContext } from "../contexts/DataProvider.js";

export default function MainContainer() {
  const navigate = useNavigate();
  const location = useLocation();

  // Use DataContext to access all data and functions
  const {
    hotlapEvents,
    hotlapEventDetails,
    groupEvents,
    selectedGroupEventDetails,
    groupSessions,
    championships,
    championshipDetails,
    leagueResults,
    circuits,
    selectedCircuit,
    vehicleRecords,
    customerRecords,
    vehicles,
    selectedVehicle,
    vehicleDetails,
    drivers,
    loading,
    loadingChampionships,
    loadingDrivers,
    loadingVehicleRecords,
    error,
    handleGroupEventSelection,
    handleChampionshipSelection,
    handleCircuitSelection,
    handleVehicleSelection,
  } = useContext(DataContext);

  // Example: Parse URL parameters to navigate to a specific screen
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const screen = searchParams.get("screen");
    const driver = searchParams.get("driver");

    if (screen) {
      // Navigate to the specified screen based on the query parameter
      if (screen === "driver-data") {
        navigate("/driver-data");
      } else if (screen === "race-results") {
        navigate("/race-results");
      } else if (screen === "championships") {
        navigate("/championships");
      } else if (screen === "circuit-records") {
        navigate("/circuit-records");
      } else if (screen === "vehicle-records") {
        navigate("/vehicle-records");
      }
      if (screen === "driver-data") {
        navigate(`/driver-data${driver ? `?driver=${driver}` : ""}`);
      }
    }
  }, [location, navigate]);

  return (
    <Routes>
      <Route path="/" element={<Home hotlapEvents={hotlapEvents} eventDetails={hotlapEventDetails} />} />
      <Route path="/driver-data" element={<DriverData drivers={drivers} loading={loadingDrivers} error={error} />} />
      <Route
        path="/race-results"
        element={<ReceResults groupEvents={groupEvents} eventDetails={selectedGroupEventDetails} sessions={groupSessions} loading={loading} onEventSelect={handleGroupEventSelection} />}
      />
      <Route
        path="/championships"
        element={
          <Championships
            championships={championships}
            championshipDetails={championshipDetails}
            leagueResults={leagueResults}
            loadingChampionships={loadingChampionships}
            handleChampionshipSelection={handleChampionshipSelection}
          />
        }
      />
      <Route
        path="/circuit-records"
        element={
          <CircuitRecords circuits={circuits} selectedCircuit={selectedCircuit} vehicleRecords={vehicleRecords} customerRecords={customerRecords} handleCircuitSelection={handleCircuitSelection} />
        }
      />
      <Route
        path="/vehicle-records"
        element={
          <VehicleRecords
            vehicles={vehicles}
            selectedVehicle={selectedVehicle}
            vehicleDetails={vehicleDetails}
            loadingVehicleRecords={loadingVehicleRecords}
            handleVehicleSelection={handleVehicleSelection}
          />
        }
      />
      <Route path="/driver/:id" element={<Customer drivers={drivers} />} />
    </Routes>
  );
}
